export enum ERetirementDocumentName {
  RETIREMENT_ACCEPTING_WORKERS = "retirement_accepting_workers",
  RETIREMENT_EMPLOYMENT_CONTRACT = "retirement_employment_contract",
}
